import cx from 'classnames';
import { Icon } from 'components/Icon';
import type { Props as IconProps } from 'components/Icon';
import { EndAdornment } from './EndAdornment';

type Props = {
  name: IconProps['name'];
  className?: string;
  iconClassName?: string;
};

export const IconEndAdornment = ({ name, iconClassName, className }: Props): JSX.Element => {
  return (
    <EndAdornment className={cx(className, 'mr-[-8px]')}>
      <Icon name={name} className={iconClassName} />
    </EndAdornment>
  );
};
